/* Lamellar Coverage Calculator — extracted from snippets/visby-calculator.liquid.
   Depends on inline globals set by the snippet: window.product, window.selectedVariantId. */

// Close modal
document.querySelector('#lamellarModal .modal-close').addEventListener('click', function () {
  document.getElementById('lamellarModal').style.display = 'none';
});
// Close on outside click
window.addEventListener('click', function (event) {
  if (event.target === document.getElementById('lamellarModal')) {
    document.getElementById('lamellarModal').style.display = 'none';
  }
});

// New calculation logic
function toCm(val, unit) {
  if (unit === 'in') return val * 2.54;
  return val;
}

// Update labels to show selected unit
function updateUnitLabels() {
  var unit = document.getElementById('unitSelect').value;
  var labels = [
    { id: 'waistCirc', label: 'Hips Circumference' },
    { id: 'chestCirc', label: 'Chest Circumference' },
    { id: 'vertDist', label: 'Armpit to Bottom of Armor' },
    { id: 'strapWidth', label: 'Strap Width' },
    { id: 'strapLength', label: 'Strap Length' },
  ];
  labels.forEach(function (field) {
    var input = document.getElementById(field.id);
    if (input) {
      var label = input.closest('label');
      if (label) {
        // Remove any previous (cm) or (inch)
        label.childNodes[0].nodeValue = field.label + ' (' + unit + '): ';
      }
    }
  });
}
document.getElementById('unitSelect').addEventListener('change', updateUnitLabels);
updateUnitLabels();

document.getElementById('calcLamellar').onclick = function () {
  const calculatorDiv = document.getElementById('lamellar-calculator');
  const pw = parseFloat(calculatorDiv.dataset.pieceWidth) || 0;
  const ph = parseFloat(calculatorDiv.dataset.pieceHeight) || 0;
  const plrh = parseFloat(calculatorDiv.dataset.pieceFirstLastRowHeight) || 1;
  const hcp = calculatorDiv.dataset.hasCenterPiece == 'true';
  const hhp = calculatorDiv.dataset.hasHalfHeight == 'true';
  const unit = document.getElementById('unitSelect').value;
  const waist = toCm(parseFloat(document.getElementById('waistCirc').value) || 0, unit);
  const chest = toCm(parseFloat(document.getElementById('chestCirc').value) || 0, unit);
  const vertDist = toCm(parseFloat(document.getElementById('vertDist').value) || 0, unit);
  const strapW = toCm(parseFloat(document.getElementById('strapWidth').value) || 0, unit);
  const strapL = toCm(parseFloat(document.getElementById('strapLength').value) || 0, unit);
  const resultDiv = document.getElementById('lamellarResult');
  const piecesPerNormal = parseInt(calculatorDiv.dataset.piecesPerNormal) || 100;
  const piecesPerCenter = parseInt(calculatorDiv.dataset.piecesPerCenter) || 10;
  const piecesPerHalf = parseInt(calculatorDiv.dataset.piecesPerHalf) || 10;
  const piecesPerHalfCenter = parseInt(calculatorDiv.dataset.piecesPerHalfCenter) || 5;

  // Calculate number of pieces per row (columns) by crawling from chest to waist
  let circumferences = [];
  let rowHeights = [];
  let currentHeight = 0;
  let totalRows = 0;
  let rowTypes = [];

  // First row (plrh)
  if (vertDist > 0 && plrh > 0) {
    rowHeights.push(plrh);
    currentHeight += plrh;
    totalRows++;
    rowTypes.push('first');
  }
  // Middle rows (ph)
  let remaining = vertDist - currentHeight;
  let midRows = 0;
  if (remaining > 0 && ph > 0) {
    midRows = Math.floor(remaining / ph);
    for (let i = 0; i < midRows; i++) {
      rowHeights.push(ph);
      currentHeight += ph;
      totalRows++;
      rowTypes.push('middle');
    }
  }
  // Last row (plrh)
  remaining = vertDist - currentHeight;
  let lastRowUsed = false;
  if (remaining > 0.5 * plrh || !hhp) {
    rowHeights.push(plrh);
    currentHeight += plrh;
    totalRows++;
    rowTypes.push('last');
    lastRowUsed = true;
  }

  // Calculate circumference at each row (linear interpolation from chest to waist)
  for (let i = 0, h = 0; i < rowHeights.length; i++) {
    // h is the vertical distance from the chest (top) to the center of this row
    let rowCenter = h + rowHeights[i] / 2;
    let frac = Math.min(Math.max(rowCenter / vertDist, 0), 1); // 0 at chest, 1 at waist
    let circ = chest + (waist - chest) * frac;
    circumferences.push(circ);
    h += rowHeights[i];
  }
  let hcpDelta = hcp ? -2 : 0;
  // Calculate pieces per row
  let piecesPerRow = circumferences.map((circ) => Math.ceil(circ / pw) + hcpDelta);
  let totalPieces = piecesPerRow.reduce((a, b) => a + b, 0);

  remaining = vertDist - currentHeight;
  halfRowPieces = null;
  if (remaining > 0 && hhp) {
    halfRowPieces = Math.ceil(waist / pw) + hcpDelta;
    totalRows++;
  }
  let pieceArea = pw * ph;
  // Strap pieces
  const strapArea = strapW * strapL;
  const strapPieces = Math.ceil(strapArea / pieceArea);
  // Display results
  let html = '<strong>Torso:</strong>:<ul>';
  html += '<li><strong>Rows of Lamellar:</strong> ' + totalRows + '</li>';
  html += '<li><strong>Normal Plates:</strong>' + totalPieces + '</li>';
  if (hcp) html += '<li><strong>Center Plates</strong>: ' + totalRows * 2 + '</li>';
  if (halfRowPieces) html += '<li><strong>Half Plates (use at Waist)</strong>: ' + halfRowPieces + '</li>';
  if (halfRowPieces) html += '<li><strong>Half Center Plates (use at Waist)</strong>: ' + 2 + '</li>';

  html +=
    '</ul><strong>Shoulder Straps</strong>:<ul><li><strong>Normal Pieces:</strong>' + strapPieces + '</li></ul>';

  html += '<strong>Suggested Order (with 10% buffer):</strong><ul>';
  html +=
    '<li><strong>Normal Plates Order:</strong> ' +
    Math.ceil(((totalPieces + strapPieces) * 1.1) / piecesPerNormal) +
    ' packs</li>';
  if (hcp)
    html +=
      '<li><strong>Center Plates Order:</strong>: ' + Math.ceil((totalRows * 1.1) / piecesPerCenter) + ' packs</li>';
  if (halfRowPieces)
    html +=
      '<li><strong>Half Plates (use at Waist)</strong>: ' +
      Math.ceil((halfRowPieces * 1.1) / piecesPerHalf) +
      ' packs</li>';
  if (halfRowPieces) html += '<li><strong>Half Center Plates (use at Waist)</strong>: 1 pack</li>';
  html += '</ul>';
  resultDiv.innerHTML = html;

  // Store suggested order for Add to Cart
  var suggested = {
    'Normal Plates': Math.ceil(((totalPieces + strapPieces) * 1.1) / piecesPerNormal),
    'Center Plates': hcp ? Math.ceil((totalRows * 1.1) / piecesPerCenter) : 0,
    'Half Plates': Math.ceil((halfRowPieces * 1.1) / piecesPerHalf) || 0,
    'Center Half Plates': halfRowPieces ? 1 : 0,
  };
  resultDiv.dataset.suggested = JSON.stringify(suggested);
  // Show Add to Cart button
  document.getElementById('addLamellarToCart').style.display = 'block';
};

// Helper: Find variant by material and type in window.product.variants
function findVariantId(material, type) {
  if (!window.product || !window.product.variants) return null;
  // Try to match by title, e.g. "Steel - Center Plate"
  type = type.toLowerCase();
  material = material.toLowerCase();
  for (var i = 0; i < window.product.variants.length; i++) {
    var v = window.product.variants[i];
    var title = v.title.toLowerCase();
    if (title.includes(material) && title.includes(type)) {
      return v.id;
    }
  }
  return null;
}

// Add to cart handler
function addLamellarToCartHandler() {
  // Get material from first option of selected variant
  var selectedVariant =
    window.product &&
    window.product.variants &&
    window.product.variants.find(function (v) {
      return v.id == window.selectedVariantId;
    });
  var material = selectedVariant ? selectedVariant.option1 : null;
  if (!material) {
    alert('Could not determine material.');
    return;
  }
  // Get suggested quantities from last calculation
  var resultDiv = document.getElementById('lamellarResult');
  if (!resultDiv.dataset.suggested) {
    alert('Please run the calculator first.');
    return;
  }
  var suggested = JSON.parse(resultDiv.dataset.suggested);
  var items = [];
  // For each type, find variant and add to items
  Object.keys(suggested).forEach(function (type) {
    var qty = suggested[type];
    if (qty > 0) {
      var variantId = findVariantId(material, type);
      if (variantId) {
        items.push({ id: variantId, quantity: qty });
      }
    }
  });
  if (!items.length) {
    alert('No matching variants found for suggested order.');
    return;
  }
  // Add all items to cart via Shopify AJAX API
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items }),
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      window.location.href = '/cart';
    })
    .catch(function (err) {
      alert('Error adding to cart.');
    });
}

document.getElementById('addLamellarToCart').onclick = addLamellarToCartHandler;

(function () {
  var modal = document.getElementById('lamellarModal');
  if (modal && modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }
  var elements = document.getElementsByClassName('openLamellarCalc');
  if (elements) {
    for (var i = 0; i < elements.length; i++) {
      elements[i].addEventListener('click', function () {
        document.getElementById('lamellarModal').style.display = 'block';
      });
    }
  }
})();

var variantSelect = document.querySelector('[name="id"]');
if (variantSelect) {
  variantSelect.addEventListener('change', function () {
    window.selectedVariantId = this.value;
  });
}
